import {
  IncidentModel,
  IncidentModelAttributes,
  IncidentCollection,
} from 'src/models/IncidentModel';
import {
  IncidentAdapterInteface,
  ListIncidentsInput as BaseListIncidentsInput,
} from 'src/adapter/IncidentAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export type ListIncidentsInput = BaseListIncidentsInput;
export class IncidentApiClass {
  adapter: IncidentAdapterInteface;
  constructor(adapter: IncidentAdapterInteface) {
    this.adapter = adapter;
  }
  async listIncidents(
    conditions: ListIncidentsInput
  ): Promise<{ total: number; incidents: IncidentCollection }> {
    try {
      conditions?.page;
      const res = await this.adapter.listIncidents({
        page: conditions.page,
        limit: conditions.limit,
        filter: conditions.filter,
      });
      return {
        total: res.total,
        incidents: res.incidents.map(
          (incident: IncidentModelAttributes) => new IncidentModel(incident)
        ),
      };
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async getIncident(id: string): Promise<IncidentModel> {
    try {
      const incident = await this.adapter.getIncident(id);
      return new IncidentModel(incident);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
}
